function sortRetirementSerial(a, b) {
  const parse = (value) => {
    if (!value) return { prefix: "", year: 0, num: 0 };

    const parts = value.split("-");
    const prefix = parts[0];
    const year = parseInt(parts[1]); // YY or YYYY
    const num = parseInt(parts[2]); // NNNNNNN

    return { prefix, year, num };
  };

  const x = parse(a.serialNumber);
  const y = parse(b.serialNumber);

  if (x.year !== y.year) return x.year - y.year;
  return x.num - y.num;
}

export const RetirementResidential = [
  {
    title: "Retired S/n",
    dataIndex: "serialNumber",
    editable: false,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: sortRetirementSerial,
    //sorter: (a, b) => a.serialNumber?.localeCompare(b.serialNumber),
  },
  {
    title: "Customer Name",
    dataIndex: "customerName",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.customerName.localeCompare(b.customerName),
  },
  {
    title: "MSSL",
    dataIndex: "mssl",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.mssl - b.mssl,
  },
  {
    title: "Geneco Account No",
    dataIndex: "accountNo",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.accountNo.localeCompare(b.accountNo),
  },
  {
    title: "Contract Number",
    dataIndex: "contractNumber",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.contractNumber.localeCompare(b.contractNumber),
  },
  {
    title: "Product Name",
    dataIndex: "productName",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.productName.localeCompare(b.productName),
  },
  {
    title: "Revenue (S$/kgCO2e)",
    dataIndex: "revenue",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.revenue.localeCompare(b.revenue),
  },
  {
    title: "Retired Date",
    dataIndex: "retiredDate",
    editable: false,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => new Date(a.retiredDate) - new Date(b.retiredDate),
  },
  {
    title: "Retirement Period Start",
    dataIndex: "retirementPeriodStart",
    editable: false,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => new Date(a.retirementPeriodStart) - new Date(b.retirementPeriodStart),
  },
  {
    title: "Retirement Period End",
    dataIndex: "retirementPeriodEnd",
    editable: false,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => new Date(a.retirementPeriodEnd) - new Date(b.retirementPeriodEnd),
  },
  {
    title: "Quantity (kgCO2e)",
    dataIndex: "quantity",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.quantity - b.quantity,
  },
  {
    title: "Cumulative Quantity(kgCO2e)",
    dataIndex: "cumulativeQuantity",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.cumulativeQuantity - b.cumulativeQuantity,
  },
  {
    title: "Active CC S/N",
    dataIndex: "activeSerialNumber",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.activeSerialNumber.localeCompare(b.activeSerialNumber),
  },
  {
    title: "Cost (S$/kgCO2e)",
    dataIndex: "cost",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.cost - b.cost,
  },
  {
    title: "Remarks",
    dataIndex: "remarks",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.remarks.localeCompare(b.remarks),
  },
];

export const RetirementSMB = [
  {
    title: "Retired S/n",
    dataIndex: "serialNumber",
    editable: false,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: sortRetirementSerial,
    // sorter: (a, b) => a.serialNumber?.localeCompare(b.serialNumber),
  },
  {
    title: "Customer Name",
    dataIndex: "customerName",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.customerName.localeCompare(b.customerName),
  },
  {
    title: "MSSL",
    dataIndex: "mssl",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.mssl - b.mssl,
  },
  {
    title: "Geneco Account No",
    dataIndex: "accountNo",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.accountNo.localeCompare(b.accountNo),
  },
  {
    title: "Contract Number",
    dataIndex: "contractNumber",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.contractNumber.localeCompare(b.contractNumber),
  },
  {
    title: "Product Name",
    dataIndex: "productName",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.productName.localeCompare(b.productName),
  },
  {
    title: "Revenue (S$/kgCO2e)",
    dataIndex: "revenue",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.revenue.localeCompare(b.revenue),
  },
  {
    title: "Retired Date",
    dataIndex: "retiredDate",
    editable: false,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => new Date(a.retiredDate) - new Date(b.retiredDate),
  },
  {
    title: "Retirement Period Start",
    dataIndex: "retirementPeriodStart",
    editable: false,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => new Date(a.retirementPeriodStart) - new Date(b.retirementPeriodStart),
  },
  {
    title: "Retirement Period End",
    dataIndex: "retirementPeriodEnd",
    editable: false,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => new Date(a.retirementPeriodEnd) - new Date(b.retirementPeriodEnd),
  },
  {
    title: "Quantity (kgCO2e)",
    dataIndex: "quantity",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.quantity - b.quantity,
  },
  {
    title: "Cumulative Quantity(kgCO2e)",
    dataIndex: "cumulativeQuantity",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.cumulativeQuantity - b.cumulativeQuantity,
  },
  {
    title: "Active CC S/N",
    dataIndex: "activeSerialNumber",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.activeSerialNumber.localeCompare(b.activeSerialNumber),
  },
  {
    title: "Cost (S$/kgCO2e)",
    dataIndex: "cost",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.cost - b.cost,
  },
  {
    title: "Remarks",
    dataIndex: "remarks",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.remarks.localeCompare(b.remarks),
  },
];

export const RetirementCnI = [
  {
    title: "Retired S/n",
    dataIndex: "serialNumber",
    editable: false,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: sortRetirementSerial,
    // sorter: (a, b) => a.serialNumber?.localeCompare(b.serialNumber),
  },
  {
    title: "Customer Name",
    dataIndex: "customerName",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.customerName.localeCompare(b.customerName),
  },
  {
    title: "MSSL",
    dataIndex: "mssl",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.mssl - b.mssl,
  },
  {
    title: "Business Registration",
    dataIndex: "accountNo",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.accountNo.localeCompare(b.accountNo),
  },
  {
    title: "Contract Number",
    dataIndex: "contractNumber",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.contractNumber.localeCompare(b.contractNumber),
  },
  {
    title: "Product Name",
    dataIndex: "productName",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.productName.localeCompare(b.productName),
  },
  {
    title: "Revenue (S$/kgCO2e)",
    dataIndex: "revenue",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.revenue.localeCompare(b.revenue),
  },
  {
    title: "Retired Date",
    dataIndex: "retiredDate",
    editable: false,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => new Date(a.retiredDate) - new Date(b.retiredDate),
  },
  {
    title: "Retirement Period Start",
    dataIndex: "retirementPeriodStart",
    editable: false,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => new Date(a.retirementPeriodStart) - new Date(b.retirementPeriodStart),
  },
  {
    title: "Retirement Period End",
    dataIndex: "retirementPeriodEnd",
    editable: false,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => new Date(a.retirementPeriodEnd) - new Date(b.retirementPeriodEnd),
  },
  {
    title: "Quantity (kgCO2e)",
    dataIndex: "quantity",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.quantity - b.quantity,
  },
  {
    title: "Cumulative Quantity(kgCO2e)",
    dataIndex: "cumulativeQuantity",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.cumulativeQuantity - b.cumulativeQuantity,
  },
  {
    title: "Active CC S/N",
    dataIndex: "activeSerialNumber",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.activeSerialNumber.localeCompare(b.activeSerialNumber),
  },
  {
    title: "Cost (S$/kgCO2e)",
    dataIndex: "cost",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.cost - b.cost,
  },
  {
    title: "Remarks",
    dataIndex: "remarks",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.remarks.localeCompare(b.remarks),
  },
];
